<template>
<!-- 点击搜索后综合页面 -->
<div class="page container">
    <panel ref="panel" :wapTitle="''" :appLink="'/2/8/0'" :spreadID="'0'" :showNav="false" :isShowNav="false" @gotoApp="gotoApp" :isApp="false"></panel>
    <!-- 搜索头部 -->
    <div class="search_top">
        <form action="/" style="display: flex;align-items: center;background: #fff;">
            <img @click="cancel" class="search_back" src="../../assets/img/Frame585_new@2x.png" alt="">
            <van-search v-model="value" show-action shape="round" background="#FFFFFF" placeholder="搜拍品、拍卖会、拍卖公司、艺术家、资讯" clearable @input="pnt" @search="search" @focus="focusValue" @blur="blurValue">
                <template #action>
                    <div @click="search">搜索</div>
                </template>
            </van-search>
        </form>

    </div>
    <div class="wordBox" v-if="focusFlag&&value&&wordList.length>0">
        <template v-for="(item, index) in wordList">
            <div class="sourceWord" :key="index+'sourceWord'" @click="jumpSearch(item)">
                <van-icon name="search" />
                <span v-html="item.source_wordShow"></span>
            </div>
        </template>
    </div>
    <!-- tab页 -->
    <div class="search_tabsmm">
        <!-- search -->
        <div class="tabItem active" data-index="0">综合</div>
        <div class="tabItem" data-index="1" @click="scFun('35','2','2'),gotoSearch('paipin')">
            拍品
        </div>
        <div class="tabItem" data-index="2" @click="scFun('35','2','3'),gotoSearch('paiacution')">
            拍卖会
        </div>
        <div class="tabItem" data-index="3" @click="scFun('35','2','4'),gotoSearch('company')">
            拍卖公司
        </div>
        <div class="tabItem" data-index="4" @click="scFun('35','2','5'),gotoSearch('market')">
            市场报告
        </div>
        <div class="tabItem" data-index="5" @click="scFun('35','2','6'),gotoSearch('infor')">
            资讯
        </div>
    </div>
    <!-- 在搜索选项有数据的时候显示的页面 -->
    <histor linkName="search" v-if="hiss" :nunber="param.type" :water="showWater"></histor>
    <!-- 在搜索没有显示的时候 -->
    <div v-if="!hiss&&!(focusFlag&&value&&wordList.length>0)">
        <!-- 拍卖公司 -->
        <div class="writer_pai" v-if="companyList.length != 0">
            <div class="writer_wen">拍卖公司</div>
            <div class="content-result">
                <div class="result-item" v-for="(item, index) in companyList" :key="index" @click="jumpToOrgen(item)">
                    <!-- 成都<span class="green">书画</span>玩家拍卖有限责任公司 -->
                    {{ item.name }}
                </div>
                <div class="result-item moreCompany" @click="gotoSearch('company')" v-if="moreAuctions">查看全部拍卖公司</div>
            </div>

        </div>
        <!-- 作者 -->
        <div class="writer_pai" v-if="artist.length != 0">
            <div class="writer_wen">艺术家</div>
            <div v-for="(item, index) in artist" :key="index">
                <div @click="scJump('12','4',(Number(index)+1),item.artCode ? '//tulu.artron.net/mark/index/'+item.artCode : item.url)" class="write_tou">
                    <div class="tou">
                        <img :src="item.headPortrait" alt="" />
                    </div>
                    <div class="title">
                        <div class="title_wenzi">{{ item.name }}</div>
                        <div class="time">{{ item.residence }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 拍品 -->
        <div class="writer_pai" v-if="auctionsList.length != 0">
            <div class="writer_wen">拍品</div>

            <div class="grid">
                <div @click="underJump(item,index)" class="grid-item" v-for="(item, index) in auctionsList" :key="index">
                    <div class="pic" v-if="item.live_info">
                        <img :src="item.detail.bigPic" alt="" />
                        <span v-if="item.isHD==1" class="bigFlag"></span>
                        <span class="live" v-if="item.live_info.have_live == 1 && item.live_info.live_status == 2">
                            <lottie class="liveIconSty" :options="heartOptions" :height="0.7" :width="0.7" />直播中
                        </span>
                        <span class="liveReview" v-else>
                            {{ item.date }}
                        </span>
                        <!-- <span class="liveReview" v-else-if="item.live_info.have_live == 1 && item.live_info.live_status == 4 && item.live_info.have_review == 1">直播回放</span> -->
                        <!-- <span class="liveStatus live" v-if="item.live_info.have_live == 1 && item.live_info.live_status == 2"><img src="../../assets/img/live.gif" alt=""></span>
                            <span class="liveStatus liveReview" v-else-if="item.live_info.have_live == 1 && item.live_info.live_status == 0 || item.live_info.live_status == 1">即将开播</span>
                            <span class="liveStatus liveReview" v-else-if="item.live_info.have_live == 1 && item.live_info.live_status == item && m.live_info.have_review == 1">直播回放</span> -->
                    </div>
                    <div class="grid-content">
                        <div class="title auction-item">
                            <span class="titSp">
                                <span :class="[
                                            'status',
                                            item.status == 1 ? 'status1' : '',
                                            item.status == 4 ? 'status2' : '',
                                            item.status == 5 ? 'status3' : '',
                                            item.status == 2 ? 'status4' : '',
                                            item.status == 3 ? 'status5' : '',
                                        ]">
                                </span>
                                <span v-html="hightLight($route.query.searchValue, item.detail.workName)">

                                </span>
                            </span>

                        </div>
                        <div class="tags" v-if="
                                    item.live_info && item.live_info.label_list
                                ">
                            <template v-for="(k, j) in item.live_info.label_list">
                                <template v-if="k.name=='同步拍'">
                                    <img :key="j" class="bidIcon" src="@/assets/img/bid_type_r.png" alt="">
                                </template>
                                <template v-else-if="k.name=='限时拍'">
                                    <img :key="j" class="bidIcon" src="@/assets/img/bid_type_b.png" alt="">
                                </template>
                                <div class="tag" v-else :class="{tagStyle:k.style==1||k.style==5}" :key="j">
                                    {{k.name}}
                                </div>
                            </template>

                        </div>
                        <div class="grid-list">
                            <div class="left">
                                <ul>
                                    <li>
                                        <span style="margin-left: 0rem;">{{item.company+' '+item.city}}</span>
                                    </li>
                                    <li :class="{'greenText' : item.live_info.have_live == 1 && item.live_info.live_status}">
                                        <template v-if="item.price.needMember==1&&isMem ==1||item.price.needMember!=1">
                                            <div class="labelText" :style="item.price.type=='now_price'?'color:#009B5F':''">{{item.price.label}}:<i :style="item.price.type=='now_price'?'color:#009B5F':''">{{item.price.smallText}}</i><span :style="item.price.type=='now_price'?'color:#009B5F':''">{{item.price.text}}</span></div>
                                            <div  :style="item.price.type=='now_price'?'color:#009B5F':''" class="labelText"><span style="color:#fff">{{item.price.label}}</span><i :style="item.price.type=='now_price'?'color:#009B5F':''">{{item.price.otherSmallText}}</i><span :style="item.price.type=='now_price'?'color:#009B5F':''">{{item.price.otherText}}</span></div>
                                        </template>
                                        <template v-else>
                                           <div class="labelText">{{item.price.label}}:<i>{{item.price.smallText}}</i><span>{{(item.price.type=='gujia'||item.price.type=='start_price'||item.price.type=='now_price'||(item.price.type=='price'&&(item.price.text=='撤拍'||item.price.text=='未提供'||item.price.text=='--')))?item.price.text:'****'}}</span></div>
                                           <div :style="item.price.type=='now_price'?'color:#009B5F':''" class="labelText"><span style="color:#fff">{{item.price.label}}</span><i :style="item.price.type=='now_price'?'color:#009B5F':''">{{(item.price.type=='gujia'||item.price.type=='start_price'||item.price.type=='now_price'||item.price.type=='price')?item.price.otherSmallText:''}}</i><span v-if="item.price.otherSmallText" :style="item.price.type=='now_price'?'color:#009B5F':''">{{(item.price.type=='gujia'||item.price.type=='start_price'||item.price.type=='now_price')?item.price.otherText:'****'}}</span></div>
                                        </template>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="((item.live_info.bid_type==1||item.live_info.bid_type==2)&&item.status!=5)" class="right" @click="gotoApp">
                                <img src="../../assets/img/goSend.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 查看更多 -->
            <div class="moreList" @click="allClick">查看全部拍品</div>
        </div>

        <!-- 资讯 -->
        <div class="writer_pai" v-if="newsList.length != 0">
            <div class="writer_wen">资讯</div>
            <div style="height: 0.8rem; width: 100%"></div>
            <div class="message_container" v-for="(item, index) in newsList" :key="index">
                <!-- 类型一 -->
                <div @click="scJump('12','6',(Number(index)+1),item.link)">
                    <div class="message_type1" v-if="item && item.pic && item.pic.length == 0">
                        <div class="tp1_title">{{ item.title }}</div>
                        <div class="tp1_bottom">
                            <div class="tp1_renshu">
                                {{ item.resource }}
                                {{ item.published_text }}
                            </div>
                            <div class="tp1_see" v-if="item.view_num != 0">
                                <img src="../../assets/img/icon_discover_yuedu_light.png" alt="" />
                                {{ item.view_num }}
                            </div>
                        </div>
                    </div>
                    <!-- 类型二 -->
                    <div class="message_type2" v-if="item && item.pic && item.pic.length == 1">
                        <div class="tp2_box">
                            <div class="tp2_title">
                                {{ item.title }}
                            </div>
                            <div class="tp2_img" v-for="(item, index) in item.pic" :key="index">
                                <img :src="item" alt="" />
                            </div>
                        </div>
                        <div class="tp2_bottom">
                            <div class="tp2_renshu">
                                {{ item.resource }}
                                {{ item.published_text }}
                            </div>
                            <div class="tp2_see" v-if="item.view_num != 0">
                                <img src="../../assets/img/icon_discover_yuedu_light.png" alt="" />{{ item.view_num }}
                            </div>
                        </div>
                    </div>
                    <!-- 类型三 -->
                    <div class="message_type3" v-if="
                                item &&
                                item.pic &&
                                item.pic.length != 0 &&
                                item.pic.length != 1
                            ">
                        <div class="tp3_title">{{ item.title }}</div>
                        <!-- 图片滑动 -->
                        <div class="tp3_sliding">
                            <div v-for="item in item.pic" :key="item">
                                <img :src="item" alt="" />
                            </div>
                        </div>
                        <div class="tp3_bottom">
                            <div class="tp3_renshu">
                                {{ item.resource }}
                                {{ item.published_text }}
                            </div>
                            <div class="tp3_see" v-if="item.view_num != 0">
                                <img src="../../assets/img/icon_discover_yuedu_light.png" alt="" />
                                {{ item.view_num }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ——————————分割线—————— -->
            </div>
        </div>
    </div>
    <share :nunber="param.type"></share>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
    <watermark v-if="showWater"></watermark>
</div>
</template>

<script>
import {
    searchZon,
    getMemType,
    searchWord
} from "@/api/auction";
import histor from "./component/histor.vue";
import share from "./component/metaComponent.vue";
import panel from "@/views/preview/component/panel";
import DownLoadApp from "@/components/common/downloadApp";
import watermark from "@/components/common/watermark";
import {
    scMdFunc
} from "@/assets/js/scData";
import lottie from '@/components/common/lottie'
const liveIcon = require('../../assets/img/live_icon_2.json')
export default {
    data() {
        return {
            showWater: false,
            isLogin: false,
            waterLink: "",
            isMem: 0,
            value: "", //搜索内容
            hiss: true,
            heartOptions: {
                animationData: liveIcon,
                loop: true,
                autoplay: true,
            },
            param: {
                type: 4,
                page: 1,
                keyword: "",
            },
            artist: [],
            companyList: [], //拍卖公司
            auctionsList: [], //拍品
            newsList: [],
            historyList: [],
            t: 0,
            moreAuctions: 0,
            focusFlag: false,
            wordList: []

        };
    },
    watch: {},
    created() {
        if (this.$route.query.searchValue) {
            this.hiss = false;
            this.value = decodeURIComponent(this.$route.query.searchValue);
            this.getsearchZon();
        }
        if (this.$route.query.from) {
            this.showWater = true;
            this.waterLink = "?from=" + this.$route.query.from;
        }
        this.getMemType()
        this.t = Date.now()
    },
    methods: {
        hightLight(keyWord, suggtion) {
            console.log(keyWord, suggtion)
            // 使用 regexp 构造函数，因为这里要匹配的是一个变量
            const reg = new RegExp(decodeURIComponent(keyWord), 'ig')
            //内容段匹配以及添加样式
            const newSrt = String(suggtion).replace(reg, function (p) {
                return "<span style='color: #009B5F'>" + p + '</span>'
            })
            // 返回处理后的值
            return newSrt
        },
        brightKeyword(e) {
            let keyword = e;
            let val = this.value;
            keyword = keyword.trim();
            if (keyword & keyword.length > 0) {
                if (keyword == val) {
                    return '<span>' + val + '</span>'
                }
                keyword = keyword.replaceAll("", "|");
                let reg = new RegExp(keyword, "ig")
                return val.replace(reg, (match) => {
                    return '<span>' + match + '</span>'
                })
            }
        },
        scJump(p = '', m = '', b = '', link) {
            scMdFunc('allClick', {
                cur_page: p,
                cur_moudle: p + '-' + m,
                cur_button: p + '-' + m + '-' + b,
            })
            window.location.href = link
        },
        scFun(p = '', m = '', b = '', dataEle) { //新单击埋点
            scMdFunc('allClick', {
                cur_page: p,
                cur_moudle: p + '-' + m,
                cur_button: p + '-' + m + '-' + b,
                ...dataEle
            })
        },
        focusValue() {
            this.focusFlag = true;
            scMdFunc('allClick', {
                cur_page: '35',
                cur_moudle: '35-1',
                cur_button: '35-1-1',
            })
            searchWord({
                keyword: this.value,
                type: 0
            }).then((res) => {
                if (res.code == 0) {
                    this.wordList = res.data.list
                    this.wordList = this.wordList.map((item) => {
                        let replaceReg = new RegExp(this.value, 'g');
                        let replaceContent = '<span style="color:#18BD6F">' + this.value + '</span>';
                        if (item.source_word.includes(this.value)) {
                            item.source_wordShow = item.source_word.replace(replaceReg, replaceContent);
                        } else {
                            item.source_wordShow = item.source_word
                        }
                        return item;
                    });
                }
            })
        },
        blurValue() {
            let that = this;

            setTimeout(() => {
                that.focusFlag = false;
            }, 500)

        },
        jumpSearch(e) {
            this.value = e.source_word;
            this.historyList = JSON.parse(localStorage.getItem("historyList")) || [];
            if (this.historyList && this.historyList.length > 14) {
                this.historyList.pop()
            }
            this.historyList.unshift(this.value);
            localStorage.setItem("historyList", JSON.stringify(this.historyList));
            this.gotoSearch('search');
            // let that = this;
            // switch (e.source_type) {
            //     case 0:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 1:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 2:
            //         that.value=e.source_word;
            //         that.gotoSearch('paipin');
            //         break;
            //     case 3:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 4:
            //         that.value=e.source_word;
            //         that.gotoSearch('paiacution');
            //         break;
            //     case 6:
            //         that.value=e.source_word;
            //         that.gotoSearch('company');
            //         break;
            //     case 7:
            //         that.value=e.source_word;
            //         that.gotoSearch('market');
            //         break;
            //     case 5:
            //         that.value=e.source_word;
            //         that.gotoSearch('infor');
            //         break;
            // }
        },
        getMemType() {
            getMemType().then((res) => {
                if (res.code == 0) {
                    this.isMem = res.data.isMember
                }
            })
        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload('/2/6', 0);
        },
        // 跳转底层页面
        // 跳转底层页面
        underJump(item, i) {
            scMdFunc('allClick', {
                cur_page: '12',
                cur_moudle: '12-5',
                cur_button: '12-5-' + Number(i + 1),
            })
            window.location.href = "https://m-auction.artron.net/trade/auction/detail/" + item.artCode;
            // this.$router.push({
            //     path: "/productdetail/" + item.artCode + this.waterLink,
            // });
        },
        jumpToOrgen(item) {
            this.$router.push({
                path: "/organ/" + item.organCode + this.waterLink,
            });
        },
        // 拍品查看全部拍品
        allClick() {
            this.$router.push({
                name: "paipin",
                query: {
                    searchValue: encodeURIComponent(this.value),
                    from: this.showWater ? this.$route.query.from : "",
                },
            });
        },
        // 取消
        cancel() {
            let url = this.showWater ? "?from=" + this.$route.query.from : "";
            scMdFunc('allClick', {
                cur_page: '35',
                cur_moudle: '35-1',
                cur_button: '35-1-2',
            })
            if (
                this.$route.query.searchType &&
                this.$route.query.searchType == "live"
            ) {
                window.location.href =
                    "https://m-auction.artron.net/live/" + url;
            } else {
                this.$router.push({
                    path: "/" + url
                });
            }
        },
        // 搜索功能
        async pnt() {
            if (!this.value) {
                this.hiss = true;
                this.param.page = 1;
                this.companyList = [];
                this.auctionsList = []; //拍品
                this.newsList = [];
                this.$router.push({
                    name: "search",
                    query: {
                        searchValue: "",
                    },
                });
            } else {
                await searchWord({
                    keyword: this.value,
                    type: 0
                }).then((res) => {
                    if (res.code == 0) {
                        this.wordList = res.data.list
                        this.wordList = this.wordList.map((item) => {
                            let replaceReg = new RegExp(this.value, 'g');
                            let replaceContent = '<span style="color:#18BD6F">' + this.value + '</span>';
                            if (item.source_word.includes(this.value)) {
                                item.source_wordShow = item.source_word.replace(replaceReg, replaceContent);
                            } else {
                                item.source_wordShow = item.source_word
                            }
                            return item;
                        });
                    }
                })
            }

        },
        // 点击搜索时触发
        search() {
            this.param.page = 1;
            this.companyList = [];
            this.auctionsList = []; //拍品
            this.newsList = [];
            if (this.value) {
                this.getsearchZon();
                // this.$router.push({
                //     name: "search",
                //     query: {
                //         searchValue: encodeURIComponent(this.value),
                //         from: this.showWater ? this.$route.query.from : "",
                //     },
                // });
                this.historyList = JSON.parse(localStorage.getItem("historyList")) || [];
                if (this.historyList && this.historyList.length > 14) {
                    this.historyList.pop()
                }
                this.historyList.unshift(this.value);
                this.hiss = false;
            } else {
                this.hiss = true;
            }
            localStorage.setItem("historyList", JSON.stringify(this.historyList));
        },
        // tab切换
        gotoSearch(link) {
            // this.$router.push({
            //     name: link,
            //     query: { searchValue: encodeURIComponent(this.value) },
            // });
            if (
                this.$route.query.searchType &&
                this.$route.query.searchType == "live"
            ) {
                this.$router.push({
                    name: link,
                    query: {
                        searchValue: encodeURIComponent(this.value),
                        searchType: "live",
                        from: this.showWater ? this.$route.query.from : "",
                    },
                });
            } else {
                this.$router.push({
                    name: link,
                    query: {
                        searchValue: encodeURIComponent(this.value),
                        from: this.showWater ? this.$route.query.from : "",
                    },
                });
            }
            this.focusFlag = false;
            //   this.$refs.tabDom.children[index].classList.add("active").
        },
        getsearchZon() {
            this.param.keyword = this.value;
            searchZon(this.param).then((res) => {
                if (res.code == 0) {
                    this.isLogin = res.data.isLogin;
                    // 拍卖品
                    this.auctionsList = res.data.auctions;
                    // 拍卖公司
                    this.companyList = res.data.company;
                    // 资讯
                    this.newsList = res.data.newsList;
                    //   艺术家
                    this.artist = res.data.artist;

                    this.moreAuctions = res.data.moreAuctions;
                }
            });
        },
        clearHis: function () {
            localStorage.removeItem('historyList');
            this.historyList = [];
        },
    },
    components: {
        histor,
        share,
        panel,
        DownLoadApp,
        lottie,
        watermark,
    },
};
</script>

<style lang="scss" scoped>
// 搜索头部和tab页面
/deep/ .van-search__content {
    background-color: #f3f3f3;

    .van-icon-search::before {
        content: ''
    }

    .van-field__left-icon .van-icon,
    .van-field__right-icon .van-icon {
        background: url("../../assets/img/icon_auc_search.png") no-repeat center;
        background-size: .7rem auto;
        width: .7rem;
    }
}

/deep/.van-search__action {
    padding: 0 .4rem;
    font-size: .85rem;
    color: #969696;
}

.search_back {
    width: 2rem;
    display: inline-block;
}

/deep/.van-search {
    width: calc(100% - 2rem);
    padding-left: 0;
}

.status {
    width: 1.9rem !important;
    height: 0.9rem !important;
    margin-right: 0.2rem !important;
    margin-top: 0 !important;
    display: inline-block !important;
    vertical-align: -0.1rem;
    margin-right: 0.2rem;
}

.wordBox {
    position: absolute;
    top: 5rem;
    left: 0;
    background: #fff;
    width: 100%;
    z-index: 9;
    min-height: calc(100vh - 6rem);

    .sourceWord {
        width: calc(100% - 1.2rem);
        margin: 0.3rem 0.6rem;
        padding: 0.3rem 0;
        font-size: 0.8rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);

        i {
            font-size: 1rem;
            vertical-align: middle;
            margin-right: 0.2rem;
        }
    }
}

.tabItem:last-child {
    padding-right: 0.9rem;
}

.search_tabsmm::-webkit-scrollbar {
    display: none;
}

.search_tabsmm {
    display: flex;
    display: -webkit-box;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    padding: 0 0.75rem;
    width: 18.75rem;
    height: 1.8rem;
    background-color: #fff;
    align-items: center;
    position: relative;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
}

.search_tabsmm:after {
    display: block;
    height: .05rem;
    width: 150%;
    position: absolute;
    bottom: .025rem;
    background-color: #dddee3;
    content: '';
    left: 0;
}

.search_tabsmm .tabItem {
    margin-right: 0.7rem;
    line-height: 1.8rem;
    height: 1.8rem;
}

.search_tabsmm .tabItem.active {
    color: #18bd6f;
    position: relative;
    z-index: 1;
    border-bottom: 0.15rem solid #18bd6f;
}

.tagStyle {
    color: #FFFFFF !important;
    border: 0;
    background: linear-gradient(87deg, #FB9C57 0%, #F22C2C 100%), rgba(0, 155, 95, 0.05) !important;
}

// 底下的
.container {
    width: 100%;
    height: auto;
    background-color: #ffffff;
}

.writer_pai {
    //   height: 1.85rem;
    background-color: #ffffff;
    border-bottom: 0.3rem solid #f7f7f7;

    .writer_wen {
        font-size: 0.8rem;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #27282d;
        margin-left: 0.75rem;
        padding-top: 0.75rem;
    }

    .write_tou {
        display: flex;
        align-items: center;
        background-color: #ffffff;

        .tou {
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
            background-color: #f7f7f7;
            margin: 0.75rem;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }

        .title {
            .title_wenzi {
                font-size: 0.8rem;
                font-family: PingFang-SC-Bold, PingFang-SC;
                font-weight: bold;
                color: #27282d;
                // line-height: 1.1rem;
            }

            .time {
                margin-top: 0.3rem;
                font-size: 0.65rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #969696;
                // line-height: 0.9rem;
            }
        }
    }
}

.grid {
    width: 18.75rem;
    background-color: #ffffff;
    padding: 0 0.75rem;
    //   margin-bottom: 2.4rem;
    margin-top: 0.05rem;
}

.grid .grid-item {
    width: 17.25rem;
    border-bottom: 0.05rem solid #dddee3;
    padding: .75rem 0;
    display: flex;
}

.grid-item .pic {
    width: 5rem;
    height: 5rem;
    border-radius: 0.6rem;
    position: relative;
    overflow: hidden;
    background: #D9D9D9;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .bigFlag {
        position: absolute;
        background: url("../../assets/img/Frame741@2x.png") no-repeat;
        width: 1.6rem;
        height: 1.6rem;
        background-size: 100%;
        right: 0;
        top: 0;
    }

    .liveStatus {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1.1rem;
        background: #1bbd6f;
    }

    .live {
        position: absolute;
        bottom: 0;
        left: 50%;
        border-radius: 1rem;
        width: 3.2rem;
        height: 1.4rem;
        line-height: 3;
        transform: translate(-50%, -20%);
        background: rgba(255, 255, 255, 0.9);
        text-align: center;
        font-size: 0.45rem;
        color: #000000;
    }

    .liveReview {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2rem;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
        font-size: 0.55rem;
        line-height: 3rem;
        color: #ffffff;
        text-align: center;
    }
}

.liveIconSty {
    display: inline-block;
    vertical-align: middle;
    background: #F6344B;
    border-radius: 0.7rem;
    margin-right: 0.2rem;
    padding: 0.2rem;
}

.status1 {
    background: url(../../assets/img/stats2.png) no-repeat;
    background-position: center;
    background-size: 100%;
    height: 0.8rem;
}

.status2 {
    background: url(../../assets/img/stats1.png) no-repeat;
    background-color: rgba(235, 81, 100, 0.10);
    background-position: center;
    background-size: 100%;
    height: 0.8rem;
}

.status3 {
    background: url(../../assets/img/stats3.png) no-repeat;
    background-color: rgba(188, 189, 190, 0.20);
    background-position: center;
    background-size: 100%;
    height: 0.8rem;
}

.status4 {
    background: url(../../assets/img/icon_list_tag_green.png) no-repeat;
    background-color: rgba(54, 153, 114, 0.10);
    background-position: center;
    background-size: 80% 70%;
    height: 0.8rem;
}

.status5 {
    background: url(../../assets/img/stats3.png) no-repeat;
    background-color: rgba(188, 189, 190, 0.20);
    background-position: center;
    background-size: 100%;
    height: 0.8rem;
}

.grid-item .grid-content {
    margin-left: 0.5rem;
    width: 13rem;
}

.grid-content .title {
    line-height: 1.05rem;
    font-size: .8rem;
    color: #27282d;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 2.1rem;
    // display: flex;
    //   align-items: center;
}

.grid-content .title .titSp {
    // width: 2.95rem;
    font-weight: 600;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.grid-content .title span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.grid-content .title .green {
    color: #18bd6f;
}

/* icon数字 5已结拍 4拍卖中 3待预展 2预展中 1待拍卖 */
.auction-item .item-icon5 {
    width: 1.9rem;
    height: 0.7rem;
    background-image: url(../../assets/img/icon_list_tag_grey@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    display: inline-block;
}

.auction-item .item-icon4 {
    width: 1.9rem;
    height: 0.7rem;
    background-image: url(../../assets/img/icon_list_tag_red@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

/* 这个待预展暂时没有图片 */
.auction-item .item-icon3 {
    width: 1.9rem;
    height: 0.7rem;
    background-image: url(../../assets/img/icon_list_tag_red@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.auction-item .item-icon2 {
    width: 1.9rem;
    height: 0.7rem;
    background-image: url(../../assets/img/icon_list_tag_green.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.auction-item .item-icon1 {
    width: 1.9rem;
    height: 0.7rem;
    display: inline-block;
    margin-right: 0.2rem;
    background-image: url(../../assets/img/icon_list_tag_green@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.tags {
    display: flex;
    margin-top: 0.5rem;
}

.tags .tag {
    padding: 0 0.2rem;
    height: 0.8rem;
    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
    background: rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    margin-right: .5rem;
    font-size: 0.5rem;
    font-family: SF Pro-Regular, SF Pro;
    font-weight: 400;
    color: #6B6C6C;
}

.tags .tag:last-child {
    margin-right: 0;
}

.bidIcon {
    height: 16px;
    margin-right: 0.5rem;
}

.grid-list {
    margin-top: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.grid-list .left li {
    margin-bottom: 0.15rem;
    line-height: .9rem;

}

.grid-list .labelText {
    font-weight: 400;
    font-size: 13px;
    color: #949596;

    span,
    i {
        font-weight: bolder;
        color: #000000;
    }
}

.grid-list .valueText {
    font-weight: 600;
    font-size: 13px;
    color: #000000;
}

.greenText {
    color: #009B5F;
}

.grid-list .left li:last-child {
    margin-bottom: 0;
}

.left li span {
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    line-height: 0.8rem;
    margin-left: 0.15rem;
}

.left li .red {
    color: #e93b3d;
}

.left li .smallred {
    color: #e93b3d;
    font-size: 0.55rem;
    margin-left: -0.03rem;
}

.grid-list .left .icon {
    width: 0.65rem;
    height: 0.65rem;
    display: inline-block;
    font-size: 0;
    line-height: 0;
    vertical-align: .3rem;
}

.left .icon img {
    width: 100%;
    height: 100%;
}

.grid-list .right {
    width: 2rem;

    img {
        width: 100%;
    }
}

.moreList {
    height: 2.5rem;
    line-height: 2.5rem;
    text-align: center;
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
}

// 公司
.content-result {
    width: 18.75rem;
    background-color: #fff;
    padding: .75rem 0.75rem 0;

}

.content-result .result-item {
    height: 2.1rem;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    border-bottom: 0.05rem solid #dddee3;
    display: flex;
    align-items: center;
}

.content-result .result-item:last-child {
    border-bottom: none;
}

.result-item .green {
    color: #18bd6f;
}

.message_container {
    margin-bottom: 0.75rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    background-color: #ffffff;
}

.moreCompany {
    text-align: center;
    justify-content: center !important;
    font-size: 0.65rem !important;
}

// 资讯
.message_type1 {
    margin-bottom: .75rem;
    padding-bottom: .75rem;
    border-bottom: .05rem solid #DDDEE3;

    .tp1_title {
        font-size: 0.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #27282d;
        line-height: 1.1rem;
        //  两行显示省略号
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .tp1_bottom {
        margin-top: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tp1_renshu {
            font-size: 0.6rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #969696;
            line-height: 0.85rem;
        }

        .tp1_see {
            font-size: 0.6rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #969696;
            line-height: 0.85rem;
            display: flex;
            align-items: center;

            img {
                margin-right: 0.1rem;
            }
        }
    }
}

.message_type2 {
    margin-bottom: .75rem;
    padding-bottom: .75rem;
    border-bottom: .05rem solid #DDDEE3;

    .tp2_box {
        display: flex;
        justify-content: space-between;

        .tp2_title {
            font-size: 0.8rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #27282d;
            line-height: 1.1rem;
            //  两行显示省略号
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }

        .tp2_img {
            width: 5.65rem;
            height: 4.15rem;
            border-radius: 0.5rem;
            margin-left: 0.5rem;
            overflow: hidden;

            // background-color: lightblue;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }

    .tp2_bottom {
        margin-top: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tp2_renshu {
            font-size: 0.6rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #969696;
            line-height: 0.85rem;
        }

        .tp2_see {
            font-size: 0.6rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #969696;
            line-height: 0.85rem;
            display: flex;
            align-items: center;

            img {
                margin-right: 0.1rem;
            }
        }
    }
}

.message_type3 {
    margin-bottom: .75rem;
    padding-bottom: .75rem;
    border-bottom: .05rem solid #DDDEE3;

    .tp3_title {
        font-size: 0.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #27282d;
        line-height: 1.1rem;
        //  两行显示省略号
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .tp3_sliding {
        height: 4.2rem;
        margin: 0.5rem 0rem;
        display: -webkit-box;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;

        div {
            width: 5.65rem;
            height: 100%;
            margin-right: 0.15rem;
            //   background-color: lightcoral;
            // margin-right:10px;
            border-radius: .5rem;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        div:last-child {
            margin-right: 0;
        }
    }

    .tp3_sliding::-webkit-scrollbar {
        display: none;
    }

    .tp3_bottom {
        margin-top: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tp3_renshu {
            font-size: 0.6rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #969696;
            line-height: 0.85rem;
        }

        .tp3_see {
            font-size: 0.6rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #969696;
            line-height: 0.85rem;
            display: flex;
            align-items: center;

            img {
                margin-right: 0.1rem;
            }
        }
    }
}

.message_container:last-child .message_type1,
.message_container:last-child .message_type2,
.message_container:last-child .message_type3 {
    border-bottom: 0;
}
</style>
